import { Suspense } from 'react';

import { Person } from '@api/lendingAPI/CustomerStateAPIHelper';
import { IconAngleLeft, IconQuestionMarkOutline } from '@iwoca/icons';
import { AlertBox, Text } from '@iwoca/orion';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { FormattedMessage } from 'react-intl';

import { PersonCard } from './PersonCard';
import { useGetCompanyShareholdersData } from './useGetCompanyShareholdersData';
import { MainContentBlockPending } from '../../../pageStructure/mainContentBlockPending/MainContentBlockPending';
import { ONBOARDING_PATHS } from '../../constants';

export const AddCompanyShareholdersForm = () => {
    const { company_shareholders } = useGetCompanyShareholdersData();

    return (
        <div className="my-l">
            <NEW_IwLink to={{ pathname: ONBOARDING_PATHS.ONBOARDING_CHECKS }}>
                <Text className="mb-xl flex flex-row gap-xs text-s font-bold text-primary-40">
                    <IconAngleLeft className="my-auto" />
                    <FormattedMessage
                        id="_.credit_card.onboarding.payment_method.back_link"
                        defaultMessage="Back to list"
                    />
                </Text>
            </NEW_IwLink>
            <div className="mx-auto max-w-4xl">
                {/* Header Section */}
                <div className="mb-xl">
                    <div className="mb-6 px-5 pb-2 sm:px-0">
                        <h1>
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.title"
                                defaultMessage="Add your major shareholders"
                            />
                        </h1>

                        <Text className="text-xl font-reg text-primary-10">
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.subtitle"
                                defaultMessage="We need details of the directors and major shareholders with 25% or more shares in your business."
                            />
                        </Text>
                    </div>

                    <AlertBox variant="connect" className="my-l flex flex-row">
                        <IconQuestionMarkOutline
                            height="20"
                            width="20"
                            className="mx-m my-auto"
                        />
                        <Text>
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.fraud_alert_message"
                                defaultMessage="We need this to protect against fraud. We are required to run anti-money laundering checks."
                            />
                        </Text>
                    </AlertBox>

                    <Text className="text-m font-reg">
                        <FormattedMessage
                            id="_.credit_card.onboarding.company_shareholders.credit_score_message"
                            defaultMessage="(don’t worry, this won’t affect anyone’s credit score)"
                        />
                    </Text>
                </div>
                {/* People List */}
                <div className="space-y-3 flex max-h-[500px] flex-col overflow-y-auto">
                    <Suspense fallback={<MainContentBlockPending />}>
                        {company_shareholders.map((person: Person) => (
                            <PersonCard person={person} key={person.uid} />
                        ))}
                    </Suspense>
                </div>
            </div>
        </div>
    );
};
